import { types } from 'mobx-state-tree';

export default types.model('TrackingUpdate', {
  description: types.string,
  created_at: types.string,
  status: types.string,
  code: types.string,
});
